import { jsx as _jsx } from "react/jsx-runtime";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import cx from "classnames";
import Image from "next/legacy/image";
import styles from "./image-gallery.module.css";
export const ImageGallery = (blok)=>{
    var ref;
    const { images  } = blok;
    return /*#__PURE__*/ _jsx("section", {
        ...storyblokEditable(blok),
        className: styles.galleryGrid,
        children: (ref = images === null || images === void 0 ? void 0 : images.filter((image)=>{
            return image === null || image === void 0 ? void 0 : image.filename;
        })) === null || ref === void 0 ? void 0 : ref.map((image, idx)=>/*#__PURE__*/ _jsx("div", {
                className: cx(styles.imageWrapper, styles[`image${idx + 1}`], {
                    [styles.mobileMargins]: idx <= 1,
                    [styles.mobileImage]: idx <= 2,
                    [styles.desktopImage]: idx > 2
                }),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image.filename,
                    alt: image.alt ?? undefined,
                    layout: "fill",
                    objectPosition: "60% center",
                    objectFit: "cover"
                })
            }, image.id))
    });
};
export default ImageGallery;
